import React, { useState } from "react";
import {
  Box,
  Text,
  Button,
  Grid,
  Label,
  Flex,
  Modal,
  ErrorMsg,
  FileUpload,
} from "atoms";
import { FormInput } from "molecules";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import MemoClose from "assets/icons/Close";
import { InvitationSentModal } from "molecules/Modals";

export const AddNewAmenitiesModal = ({
  isOpen,
  onClose,
  title,
  preRecord,
  onSubmit,
  loading,
  error,
  resetError,
}) => {
  const [isConfirmModalVisible, setConfirmModalVisible] = useState(false);

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <Box width={{ md: "50rem" }}>
          <Box p={{ xs: "2.4rem", lg: "3.2rem" }}>
            <Flex
              justifyContent="space-between"
              borderBottom="0.1rem solid"
              borderColor="neutral.100"
              pb="2.4rem"
            >
              <Text
                fontSize="2rem"
                color="primary.900"
                fontFamily="primaryBold"
              >
                {preRecord ? "Edit" : "Add New"} {title || ""}
              </Text>
              <Box
                color="neutral.900"
                onClick={onClose}
                cursor="pointer"
                textAlign="right"
              >
                <MemoClose height="1.6rem" width="1.6rem" />
              </Box>
            </Flex>
            <Formik
              initialValues={{
                name: preRecord?.name || "",
                icon: preRecord?.icon || "",
              }}
              onSubmit={onSubmit}
              validationSchema={Yup.object().shape({
                name: Yup.string().required("Name is required"),
                icon: Yup.string()
                  .typeError("Choose an image")
                  .required("Choose an image"),
              })}
            >
              {({ values, setFieldValue, touched, errors }) => {
                return (
                  <Form>
                    <Grid gridRowGap="2.4rem" mt="1.8rem">
                      <Grid gridRowGap="1.6rem">
                        <Label text="Name" req />
                        <FormInput
                          name="name"
                          placeholder="Enter Name"
                          req
                          onChange={(e) => {
                            setFieldValue("name", e?.target?.value);
                            error && resetError();
                          }}
                        />
                      </Grid>

                      <Box>
                        <Label text={`Upload ${title} Icon`} mb="1.6rem" req />
                        <FileUpload
                          files={
                            values?.icon
                              ? [
                                  {
                                    image: values?.icon,
                                    alt: values?.iconAlt,
                                  },
                                ]
                              : []
                          }
                          onUpload={(locations) => {
                            const newProjectImages = [
                              ...(values?.images
                                ? JSON.parse(JSON.stringify(values?.images)) ||
                                  []
                                : []),
                              ...locations,
                            ];

                            setFieldValue("icon", newProjectImages[0]);
                          }}
                          isMultiple={false}
                          isAltText={false}
                          onSubmitDescription={({ alt }) => {
                            setFieldValue(`iconAlt`, alt);
                          }}
                          onCross={(index) => {
                            setFieldValue("icon", "");
                            setFieldValue("iconAlt", "");
                          }}
                        />
                        {touched?.icon && errors?.icon && (
                          <ErrorMsg text={errors?.icon} />
                        )}
                      </Box>

                      {error && <ErrorMsg text={error} />}

                      <Button
                        variant="primary"
                        type="submit"
                        height={{ xs: "4.3rem", lg: "4.8rem" }}
                        loading={loading}
                      >
                        Save
                      </Button>
                    </Grid>
                  </Form>
                );
              }}
            </Formik>
          </Box>
        </Box>
      </Modal>
      {isConfirmModalVisible && (
        <InvitationSentModal
          isOpen={isConfirmModalVisible}
          onClose={() => setConfirmModalVisible(false)}
        />
      )}
    </>
  );
};
